<template>
  <div class="big">
    <ReturnVisit
      :isFlag="return_visit"
      :businessId="doctorId"
      :visitType="visitType"
      :visitName="visitName"
      :sms_type="3"
      :activeIndexDia="activeIndexDia"
    ></ReturnVisit>
    <div class="page_title flex between">
      <span>
        <span>医生信息详情</span>
        <el-button
          type="primary"
          style="width: 80px; margin-left: 20px"
          size="medium"
          @click="toReturn"
          :disabled="
            module_id_array[0] ? !module_id_array.includes('1315') : false
          "
          >回访</el-button
        >
      </span>
      <el-button type="primary" style="width: 92px" size="medium" @click="back"
        >返回</el-button
      >
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div>
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item index="1" style="font-size: 16px"
              >基本信息</el-menu-item
            >
            <el-menu-item index="2" style="font-size: 16px"
              >其他信息</el-menu-item
            >
          </el-menu>
        </div>
        <div class="box">
          <div class="component">
            <component :is="currentComponent" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BasicMsg from "./BasicMsg";
import OtherMsg from "./OtherMsg";
import xx from "./xx";
import ReturnVisit from "../../../components/common/ReturnVisit.vue";
export default {
  data() {
    return {
      activeIndex: "1",
      active: "1",
      doctorId: 0,
      return_visit: false,
      visitName: "doctor",
      visitType: 1,
      activeIndexDia: "1",
    };
  },
  computed: {
    currentComponent() {
      switch (this.active) {
        case "1":
          return BasicMsg;
        case "2":
          return OtherMsg;
        default:
          return BasicMsg;
      }
    },
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  components: {
    ReturnVisit,
  },
  methods: {
    handleSelect(key, keyPath) {
      this.active = key;
    },
    back() {
      history.back();
    },
    //回访
    toReturn() {
      this.doctorId = this.$route.query.doctor_id;
      this.return_visit = !this.return_visit;
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 200px);
}
.box {
  width: 100%;
  box-sizing: border-box;
  .component {
    width: 100%;
    box-sizing: border-box;
  }
}
</style>
